export const EmitEvents = {
    ClientModal: {
        CompleteSearch: "CompleteSearch",
    },
    HospitalRental: {
        CompleteSelect: "CompleteSelect",
    },
    SignModal: {
        SelectSignMethod: "SelectSignMethod",
    },
    SummaryModal: {
        SummaryConfirm: "SummaryConfirm",
    },
    Common: {
        CloseModal: "CloseModal",
    }
}
